import styles from './ClientInnerPageLayout.module.css';

import ClientsIcon from '../assets/icons/clients.svg?react';
import CreateOrderIcon from '../assets/icons/create_order.svg?react';
import LogoutIcon from '../assets/icons/logout.svg?react';
import MedicinesIcon from '../assets/icons/medicines.svg?react';
import OrderHistoryIcon from '../assets/icons/order_history.svg?react';
import type { FC, PropsWithChildren } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { DefaultAvatarIcon, Logo } from '../components';
import { RoutePath } from '../config';
import { useAuthContext, useProfile } from '../hooks';

export const DoctorInnerPageLayout: FC<PropsWithChildren> = ({ children }) => {
  const profile = useProfile();
  const { signOut } = useAuthContext();
  const location = useLocation();
  sessionStorage.setItem('lastPath', location.pathname);

  return (
    <div className="grid min-w-[1280px] grid-cols-[200px_1fr] gap-[20px] p-[12px]">
      <aside className="flex flex-col gap-[22px] pl-[8px]">
        <header className="ml-[16px] mt-[28px]">
          <Logo />
        </header>
        <div className="flex-1">
          <div className="grid gap-[4px] whitespace-nowrap">
            <NavLink className={styles.item} to={RoutePath.DoctorCreateOrder}>
              <CreateOrderIcon />
              Собрать заказ
            </NavLink>
            <NavLink className={styles.item} to={RoutePath.DoctorPatients}>
              <ClientsIcon />
              Пациенты
            </NavLink>
            <NavLink className={styles.item} to={RoutePath.DoctorOrderHistory}>
              <OrderHistoryIcon />
              Заказы и платежи
            </NavLink>
            <NavLink className={styles.item} to={RoutePath.DoctorMedicine}>
              <MedicinesIcon />
              Препараты
            </NavLink>
          </div>
        </div>
        <footer className="pb-[20px]">
          <span className={styles.item}>
            {profile?.avatar ? (
              <img
                alt="Avatar"
                height={40}
                width={40}
                src={profile.avatar}
                className="size-[40px] rounded-[50%] object-cover"
              />
            ) : (
              <DefaultAvatarIcon className="size-[40px]" />
            )}
            {profile?.name}
          </span>
          <hr className="my-[13px] border-brand-1/20" />
          <button
            className={styles.item}
            onClick={() => {
              signOut();
            }}
            type="button"
          >
            <LogoutIcon />
            Выйти
          </button>
        </footer>
      </aside>
      <div className="min-h-[calc(100vh-24px)] rounded-[16px] bg-brand-3 p-[36px]">
        {children}
      </div>
    </div>
  );
};
